import {DATE_FORMAT, DATETIME_FORMAT} from "../const";

const moment = require('moment');

export function filterTest(string) {
    return string + ' filtered'
}

export function numberOrDash(number) {
    return number ? number : '-';
}

export function customDate(date) {
    return date ? moment(date).format(DATE_FORMAT) : null;
}

export function customDateTime(date) {
    return date ? moment(date).format(DATETIME_FORMAT) : null;
}

export function join(values) {
    return values.join(', ');
}

export function dateRange(date, key)
{
    let range = {
        startDate: null,
        endDate: moment(date).format(moment.HTML5_FMT.DATE),
    };

    let interval = null;

    switch (key)
    {
        case 1:
            interval = 'week';
            break;
        case 2:
            interval = 'month';
            break;
        case 3:
            interval = 'year';
            break;
    }

    if (!interval) {
        return range;
    }

    range.startDate = moment(date).subtract(1, interval).format(moment.HTML5_FMT.DATE);

    return range;
}


// WEBPACK FOOTER //
// ./src/filters/index.js